import { useDispatch } from "react-redux";
import React, { useContext, useEffect } from "react";
import styles from "./homepage.module.scss";
import Favorites from "./favourites/Favorites";
import HomePageCountCards from "views/pages/manage/homepage/countCards/HomePageCountCads";
import Notifications from "views/pages/manage/homepage/notifications/Notifications";
import useFetchBusinessAreas from "./customHooks/useFetchBusinessAreas";
import { PermissionContext } from "appContext";
import { getScreenIds } from "./constant";
import ALoader from "../common/a-loader";

import { setMasterDropdowns } from "redux/globalData/globalDataAction";

// this is new Homepage
// once complete dev is done old index.js file shall be deleted and this file sholud be served from custom routes

const Homepage = () => {
  const dispatch = useDispatch();

  const [businessAreas, fetchingBusinessAreas] = useFetchBusinessAreas();

  useEffect(() => {
    if (businessAreas?.length) {
      dispatch(
        setMasterDropdowns({
          businessArea: businessAreas.map((item) => ({
            ...item,
            label: `${item.businessAreaDispValue}`,
            value: item.businessAreaDispValue,
            businessAreaId: item.id,
            businessAreaDesc: item.businessAreaDesc,
            regionId: item.regionId || "",
            gstInNumber: item.gstInNumber || "",
          })),
        })
      );
    }
  }, [businessAreas]);

  const screenIds = getScreenIds(useContext(PermissionContext));

  return (
    <div className="remove-container-top-space min-page-height d-flex">
      {fetchingBusinessAreas && <ALoader position={"fixed"} />}
      <div className={`${styles?.homepageContainer}`}>
        <Favorites />
        {businessAreas?.length <= 5 && (
          <HomePageCountCards
            businessAreas={businessAreas}
            fetchingBusinessAreas={fetchingBusinessAreas}
            screenIds={screenIds}
          />
        )}
      </div>
      <Notifications
        businessAreas={businessAreas}
        fetchingBusinessAreas={fetchingBusinessAreas}
        screenIds={screenIds}
      />
    </div>
  );
};

export default Homepage;
